<template>
  <div class="schedule">
    <div class="panelheader">
      <div class="title">{{pageName}}</div>
    </div>
    <el-row>
      <el-col :lg='{span: 18}' :md='{span: 18}' :sm='{span: 24}' :xs='{span: 24}'>
        <div class="scheduler-container" style="text-align: center;" v-loading="schedulerLoading">
          <div id="scheduler" class="dhx_cal_container centered" style='width:90%; height:95%; margin: 0 auto;'>
            <div class="dhx_cal_navline">
              <div class="dhx_cal_prev_button">&nbsp;</div>
              <div class="dhx_cal_next_button">&nbsp;</div>
              <div class="dhx_cal_date"></div>
              <div class="dhx_cal_tab" name="day_tab" style="right:204px;"></div>
              <div class="dhx_cal_tab" name="week_tab" style="right:140px;"></div>
              <div class="dhx_cal_tab" name="month_tab" style="right:76px;"></div>
            </div>
            <div class="dhx_cal_header"></div>
            <div class="dhx_cal_data"></div>
          </div>
        </div>
      </el-col>

      <el-col :lg='{span: 6}' :md='{span: 6}' :sm='{span: 24}' :xs='{span: 24}'>
        <div class="scheduler-list">
          <div class="site-select">
            <div>Select a site</div>
            <el-select v-model="site" placeholder="Select" no-data-text="No Sites">
              <el-option
                v-for="item in sites"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>

          <!-- RIGHT FIELDS COLUMN-->
          <el-table
            ref="fieldSelectTable"
            highlight-current-row
            :data="fields"
            style="width: 95%"
            @row-click="handleFieldClick"
            @current-change="handleCurrentChange"
            empty-text="No Fields"
            class="site-table"
            v-if="site">

            <el-table-column label="Fields">
              <template slot-scope="props">
                <div class="field-selector">
                  <span class="name">{{ props.row.field_name }}</span>
                  <span class="colourBox" :style="{'background-color': props.row.colour}"></span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <!-- MODAL -->
    <el-dialog
      class="scheduler_modal"
      title='Schedule'
      :visible.sync="dialogVisible"
      width="65%"
    >
      <div v-loading="lightboxLoading" :element-loading-text="loadingText">
        <el-form :rules="validators" id="custom_form" ref="booking" :model="booking" label-width="180px">

          <el-row>
            <el-col :span="24">
              <el-form-item label="Club" prop="club_id">
                <el-select v-model="booking.club_id" name="club_id">
                  <el-option
                    v-for="club in clubs"
                    :key="club.id"
                    :value="club.id"
                    :label="club.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="Title (optional)" prop="title">
                <el-input v-model="booking.title" placeholder="Give booking a name?" name="title"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="From" prop="time">
                <el-time-select
                  placeholder="Start time"
                  v-model="booking.start_time"
                  class="time-from"
                  :editable="false"
                  :picker-options="{
                    start: '08:30',
                    step: '00:15',
                    end: '23:59',
                    maxTime: booking.end_time
                  }">
                </el-time-select>
              </el-form-item>

              <el-form-item label="To" prop="time">
                <el-time-select
                  placeholder="End time"
                  v-model="booking.end_time"
                  class="time-to"
                  :editable="false"
                  :picker-options="{
                    start: '08:30',
                    step: '00:15',
                    end: '23:59',
                    minTime: booking.start_time
                  }">
                </el-time-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item :label="fieldsLabel" prop="field_ids">

                <el-row>
                  <el-col :span="20">
                    <el-select
                      v-for="sel in selObjs"
                      :key="sel"
                      v-model="booking.field_ids[sel]"
                      placeholder="Select a field"
                      no-data-text="No Fields"
                    >
                      <el-option
                        v-for="item in fields"
                        :key="item.id"
                        :label="item.field_name"
                        :value="item.id"
                        :disabled="item.disabled"
                        v-if="item.id > -1"
                      >
                      </el-option>
                    </el-select>
                  </el-col>

                  <el-col :span="1">
                    <el-button
                      v-if="!updatingBooking && booking.field_ids.length && fields.length !== fields.filter(v => v.disabled).length"
                      type="save"
                      @click="handleFieldAddClick"
                      style="position: absolute; bottom: 0"
                    >
                      +
                    </el-button>
                  </el-col>


                  <el-col :span="1" :offset="2">
                    <el-button
                      v-if="booking.field_ids.length > 1"
                      type="cancel"
                      @click="handleFieldRemClick"
                      style="position: absolute; bottom: 0"
                    >
                      -
                    </el-button>
                  </el-col>

                </el-row>

              </el-form-item>

              <el-form-item label="Select scenes" prop="scene_id" v-if="booking.field_ids.length > 1">
                <el-select
                  name="scene_select"
                  v-model="booking.scene_ids"
                  multiple
                  placeholder="Select scenes"
                  no-data-text="No Scenes"
                  :disabled="sceneDisabled"
                  >
                  <el-option
                    v-for="item in scenes"
                    :key="item.scene_id"
                    :label="item.scene_name"
                    :value="item.scene_id"
                    :disabled="item.disabled">
                    <span style="float: left">{{ item.scene_name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 80%">{{ item.field_name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Select scene" prop="scene_id" v-else>
                <el-select
                  name="scene_select"
                  v-model="booking.scene_ids[0]"
                  placeholder="Select scene"
                  no-data-text="No Scenes"
                  :disabled="sceneDisabled"
                  >
                  <el-option
                    v-for="item in scenes"
                    :key="item.scene_id"
                    :label="item.scene_name"
                    :value="item.scene_id">
                    <span style="float: left">{{ item.scene_name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 80%">{{ item.field_name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <div v-if="updatingBooking">
                <el-form-item label="Update recurring?" v-if="recurringIds[eventId]" prop="updateRecurring">
                    <el-radio-group v-model="alsoUpdateRecurring">
                      <el-radio :label="0">This booking</el-radio>
                      <el-radio :label="1">This and following bookings</el-radio>
                      <el-radio :label="2">All bookings</el-radio>
                    </el-radio-group>
                    <!-- <el-switch v-model="alsoUpdateRecurring" inactive-text="" active-text="" style="float: left; padding: 10px"></el-switch> -->
                </el-form-item>

                <div v-if="alsoUpdateRecurring" style="padding-bottom: 8px">
                  Updating {{ recurringCount }} bookings.
                </div>

                <el-form-item v-if="alsoUpdateRecurring">
                  <el-select v-model="recurringFreq" placeholder="Fequency">
                    <el-option
                      v-for="freq in recurringFreqs"
                        :key="freq.name"
                        :label="freq.name"
                        :value="freq.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <div class="dayOptWrapper" v-if="alsoUpdateRecurring && recurringFreq > 1">
                  <el-checkbox-group v-model="recurringDays" size="medium" prop="recurringDays">
                    <el-checkbox-button v-for="day in dayOptions" :key="day.id" :label="day.id">{{day.name}}</el-checkbox-button>
                  </el-checkbox-group>
                </div>

                <div class="endDateWrapper" v-if="alsoUpdateRecurring">
                  <el-form-item label="Start From" prop="recurringStart">
                    <el-date-picker v-model="recurringStart" placeholder="Select a start date"></el-date-picker>
                  </el-form-item>

                  <el-form-item label="End date" prop="recurringEnd">
                    <el-date-picker v-model="recurringEnd" placeholder="Select an end date" :picker-options="recurringEndOptions"></el-date-picker>
                  </el-form-item>
                </div>

              </div>

              <div v-else>
                <el-form-item label="Recurring Bookings?" prop="recurringBookings">
                  <el-select v-model="recurringFreq" placeholder="Fequency">
                    <el-option
                      v-for="freq in recurringFreqs"
                        :key="freq.name"
                        :label="freq.name"
                        :value="freq.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <div class="dayOptWrapper" v-if="recurringFreq > 1">
                  <el-checkbox-group v-model="recurringDays" size="medium" prop="recurringDays">
                    <el-checkbox-button v-for="day in dayOptions" :key="day.id" :label="day.id">{{day.name}}</el-checkbox-button>
                  </el-checkbox-group>
                </div>

                <div class="endDateWrapper" v-if="recurringFreq">
                  <el-form-item label="Start From" prop="recurringStart">
                    <el-date-picker v-model="recurringStart" placeholder="Select a start date"></el-date-picker>
                  </el-form-item>

                  <el-form-item label="End date" prop="recurringEnd">
                    <el-date-picker v-model="recurringEnd" placeholder="Select an end date" :picker-options="recurringEndOptions"></el-date-picker>
                  </el-form-item>
                </div>

              </div>

            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">

              <span :disabled="recurringFreq && !recurringEnd">
                <el-button type="save" class="save-btn" @click="save_form">Save</el-button>
              </span>

              <el-button type="cancel" class="cancel-btn" @click="close_form">Cancel</el-button>
              <el-button v-if="updatingBooking" type="danger" @click="startDelete(eventId)">Delete</el-button>
            </el-col>
          </el-row>


        </el-form>
      </div>
    </el-dialog>

    <!-- DELETE CONFIRM -->
    <el-dialog
      :visible.sync="showDeleteConfirm"
      width="50%"
      >
      <div v-loading="deleting">
        <h3 slot="title" style="text-align: left;">
          Delete booking?
        </h3>
        <div>Are you sure you wish to delete this booking?</div>
        <div>This is <strong>permanent</strong> and can't be undone</div>

        <span slot="footer">
          <el-form v-if="recurringIds[deleteId]">
            <el-form-item label="Delete all recurring after this?">
              <el-switch v-model="deleteRecurring" style="float: left; padding: 5px;" active-color="#FF0000" active-text="" inactive-text=""></el-switch>
            </el-form-item>
          </el-form>

          <el-button @click="showDeleteConfirm = false">Cancel</el-button>
          <el-button type="danger" @click="doDelete" :disabled="deleting">Delete</el-button>
        </span>
      </div>

    </el-dialog>
  </div>
</template>

<script>

  import 'dhtmlx-scheduler'

  import auth from '../auth';
  import requests from '../requests';
  import { debounce } from "lodash";

  import escape from 'escape-html';
  // import Promise from 'bluebird'

  var socket = io();

  export default {
    data() {
      var validateFieldIds = (rule, value, callback) => {
        if (!value || !value.length) {
          callback(new Error('Cannot be empty'));
        } else if ( value.length !== this.booking.scene_ids.length ) {
          callback(new Error('Please select a scene for every field'))
        }
        callback();
      };
      var validateSceneIds = (rule, value, callback) => {
        if (!value || !value.length) {
          callback(new Error('Cannot be empty'));
        } else if ( value.length !== this.booking.field_ids.length ) {
          callback(new Error('Please select a scene for every field'))
        }
        callback();
      };
      return {
        tableData: [],
        pageName: "Book a field",
        dialogVisible: false,
        booking:{
          date: '',
          start_time: '',
          end_time: '',
          field_id:'',
          scene_id:'',
          title: '',
          field_ids: [],
          scene_ids: [],
          club_id: 0
        },
        sites:[],
        site:'',
        scenes:[],
        fields: [],
        fieldSelect: -1,
        allEvents: [],
        time:'',
        colourMap: {
          '0': '#6396d8',
          '1': '#77cba4',
          '2': '#779ecb',
          '3': '#cb779e',
          '4': '#cba477',
          '5': '#cb7a77',
          '6': '#c8cb77',
          '7': '#77c8cb',
          '8': '#cb77c8',
          '9': '#4d1d33'
        },
        validators: {
          field_ids: [
            { validator: validateFieldIds, trigger: 'blur' }
          ],
          scene_ids: [
            { validator: validateSceneIds, trigger: 'blur' }
          ],
          recurringEnd: [
            { validator: this.validateRecurringEnd, trigger: 'blur' }
          ]
        },
        isLarge: true,
        sceneDisabled: true,
        recurringDays: [],
        dayOptions: [
          {id: 0, name: 'Sun'},
          {id: 1, name: 'Mon'},
          {id: 2, name: 'Tue'},
          {id: 3, name: 'Wed'},
          {id: 4, name: 'Thu'},
          {id: 5, name: 'Fri'},
          {id: 6, name: 'Sat'},
        ],
        recurringFreqs: [
          { id: 0, name:'None' },
          { id: 1, name:'Daily' },
          { id: 2, name:'Weekly' },
          { id: 3, name:'Fortnightly' },
          // { id: 4, name:'Monthly' },
          // { id: 5, name:'Bimonthly' }
        ],
        recurringFreq: 0,
        recurringStart: null,
        recurringEnd: null,
        recurringEndOptions: {
          disabledDate: this.disableRecurringDate
        },
        alsoUpdateRecurring: 0,
        updatingBooking: false,
        eventId: -1,
        recurringIds: {},
        showDeleteConfirm: false,
        deleteId: 0,
        deleteRecurring: false,
        firstChange: false,
        lastRefresh: new Date(),
        lightboxLoading: false,
        deleting: false,
        loadingText: '',
        schedulerLoading: false,
        selObjs: [0],
        clubs: [{id: 0, name: 'No Club'}]
      }
    },
    methods: {
      getAllSites: debounce(

        function(){
          var context = this;
          requests.getAllSitesFields(context, function(result){
            var sites = result.data;
            if(!sites){
              return false;
            }
            for(var i = 0; i < sites.length; i++){
              if(!sites[i]['fields']){
                sites[i]['fields'] = [];
              }
              context.sites.push(sites[i]);
              context.site = sites[0].id;
            }
          });
        }, 200
      ),
      disableRecurringDate(date) {
        var oneDay = (1000*60*60*24);
        if(date.getTime() < Date.now() - oneDay) return true; //Disable if date is yesterday or before
        return date.getTime() < new Date(this.booking.date).getTime() - oneDay; //Disable if before booking date
      },
      handleFieldClick(row, event) {
        this.fieldSelect = row.id;
      },
      handleCurrentChange(currentRow, oldCurrentRow) {

      },
      setCurrent(row) {
        this.$refs.fieldSelectTable.setCurrentRow(row);
      },
      save_form() {
        var context = this;

        this.$refs['booking'].validate((valid) => {
          if (!valid) {
            console.log('error submit!!');
            this.dialogVisible = true;
            return false;
          } else {

            this.lightboxLoading = true;

            var custom_form = document.getElementById("custom_form");

            //Gets most recent event
            var createdEv = scheduler.getEvent(this.eventId) || scheduler.getEvent(Math.max(...this.allEvents.map(v => v.id)))

            if (this.recurringEnd) {
              var s = new Date(this.recurringStart || this.booking.date)
              var e = new Date(this.recurringEnd)
              var oneDay = 24 * 60 * 60 * 1000
              var maxNumBookings = Math.round((e - s) / oneDay) * this.booking.field_ids.length + 1
              this.loadingText = `Creating up to ${maxNumBookings} bookings...`
            }

            Promise.all(this.booking.field_ids.map((field_id, i) => {
              return new Promise((resolve, reject) => {

                var scene_id = this.booking.scene_ids[i]

                // Deepcopy event for each field
                var ev = JSON.parse(JSON.stringify(createdEv))
                delete ev.id

                ev = scheduler.getEvent(scheduler.addEvent(ev))

                if(this.booking.field_ids.length > 1) {
                  ev.id = parseInt(this.eventId) + i
                } else {
                  ev.id = this.eventId
                }

                var title = custom_form.elements.namedItem('title').value;

                var scene, field;
                this.scenes.map(s => {
                  if(s.scene_id === scene_id) {
                    scene = s.scene_name;
                    field = s.field_name;
                  }
                })

                this.sites.map(s => {
                  if(!s.fields || !s.fields.length) {
                    ev.site_id = -1
                  } else {
                    if(s.fields.filter(f => f.id === this.booking.field_id).length) {
                      ev.site_id = s.id
                    }
                  }
                })

                const club_name = custom_form.elements.namedItem('club_id').value;
                ev.text = (title || field.toUpperCase() + ':' + scene) + club_name;

                ev.deleted = -1;
                ev.scene_id = scene_id;
                ev.field_id = field_id;
                ev.color = this.colourMap[field_id % 10];

                var data = this.booking;
                data['id'] = ev.id;
                data['title'] = title;
                data['scene_name'] = scene;
                data['field_name'] = field;
                data['scene_id'] = scene_id;
                data['field_id'] = field_id;
                data['site_id'] = ev.site_id;

                data['recurringFreq'] = this.recurringFreq;
                data['recurringDays'] = this.recurringDays;
                data['recurringEnd'] = this.recurringEnd;
                data['recurringStart'] = this.recurringStart;

                if(ev.update){
                  var sdate = this.booking.date + ' ' + this.booking.start_time;
                  var edate = this.booking.date + ' ' + this.booking.end_time;
                  var d1 = new Date(sdate);
                  var d2 = new Date(edate);
                  ev.start_date = d1;
                  ev.end_date = d2;
                  ev.start_time = d1.toISOString();
                  ev.end_time = d2.toISOString();

                  data['updateRecurring'] = this.alsoUpdateRecurring;
                  data['recurring_id'] = this.recurringIds[ev.id];

                  requests.updateBooking(context, ev.id, data, function(result){
                    if(result.action === 'success') {
                      // context.dialogVisible = false;
                      var msg = "Successfully updated booking.";
                      if(result.data && typeof result.data === 'object' && result.data.length > 1) {
                        msg = `Successfully updated ${result.data.length} bookings.`
                      };

                      context.$message({
                        showClose: true,
                        type: 'success',
                        message: msg,
                      });

                    } else if(result.action === 'warning') {
                      var fails = result.data.filter(v => v.action === 'Fail');

                      context.$message({
                        showClose: true,
                        type: 'warning',
                        message: `${fails.length} of your ${result.data.length} bookings overlap with existing bookings or are in the past. Please check your upcoming bookings for clashes.`
                      });
                      console.log(fails)

                    } else {
                      var msg = "Error updating booking. " + (result.msg || null)
                      if(result.data && typeof result.data === 'object' && result.data.length > 1) {
                        msg = result.msg + '\n' + result.data.map(v => v.msg).join('\n');
                      }

                      context.$message({
                        showClose: true,
                        type: 'error',
                        message: msg,
                      });
                      // return false;
                    }
                    return resolve('update')
                  });

                } else {

                  requests.newBooking(context, data, function(result){
                    if(result.action && result.action === 'success'){

                      var msg = "Successfully created booking.";
                      if(result.data && typeof result.data === 'object' && result.data.length > 1) {
                        msg = `Successfully created ${result.data.length} bookings.`
                      }

                      context.$message({
                        showClose: true,
                        type: 'success',
                        message: msg
                      });

                    } else if (result.action && result.action === 'warning') {
                      var fails = result.data.filter(v => v.action === 'Fail');

                      context.$message({
                        showClose: true,
                        type: 'warning',
                        message: `${fails.length} of your ${result.data.length} bookings overlap with existing bookings or are in the past. Please check your upcoming bookings for clashes.`
                      });
                      console.log(fails)

                    } else {

                      var msg = 'Error creating booking. ' + (result.msg || null);
                      if(result.data && typeof result.data === 'object' && result.data.length > 1) {
                        msg = result.msg + '\n' + result.data.map(v => v.msg).join('\n');
                      }

                      context.$message({
                        showClose: true,
                        type: 'error',
                        message: msg
                      });
                    }
                    return resolve('new')
                  });
                }
              })
            })).then(pRes => {
              this.refreshEvents(this.fieldSelect, true, function(res) {
                if(res && res.slice) {
                  context.dialogVisible = false
                  context.lightboxLoading = false
                  context.loadingText = ''
                }
              });
            }, err => {
              console.log(err)
              context.lightboxLoading = false
              context.loadingText = ''
              context.$message({
                type: 'error',
                message: 'Something went wrong. Please refresh and try again',
                showClose: true
              })
            }).then(() => {
              context.resetValues()
            })
          }
        })

      },
      close_form() {
        //Delete if not initialised/saved yet. Deleted won't be an attribute yet
        var ev = scheduler.getEvent(this.eventId);
        if (ev.update) {
          this.dialogVisible = false;
        } else {
          this.dialogVisible = false;
          scheduler.deleteEvent(this.eventId);
        }

        this.resetValues();
      },
      resetValues () {
        // Reset length of selected fields, scenes and recurring
        this.selObjs = [0]
        this.scenes = []
        this.alsoUpdateRecurring = 0
      },
      visible(){
        this.dialogVisible = true;

        if (this.recurringIds[this.eventId]) {
          const recurringGroup = this.allEvents.filter(ev => ev.recurring_id === this.recurringIds[this.eventId]) // All in recurring group

          this.recurringDays =  recurringGroup
            .map(ev => new Date(ev.start_time).getDay())
            .filter((day, i, days) => days.indexOf(day) === i) // Get unique days of the week
            .sort()

          this.recurringFreq = this.getRecurringFreq(recurringGroup)

        } else {
          this.recurringDays = [new Date(this.booking.date).getDay()];
        }
      },
      getRecurringFreq (recurringGroup) {
        const day = 24 * 60 * 60 * 1000

        const days = recurringGroup.map(booking => new Date(booking.start_time))
        const totalDays = ((days.slice(-1)[0] - days[0]) / day) + 1

        if (totalDays === recurringGroup.length) {
          return 1 // Daily
        }

        const leadingDays = recurringGroup
          .map(booking => new Date(booking.start_time))
          .filter((date, i, arr) => date.getDay() === arr[0].getDay()) // Get all the dates matching the first day in the array

        const daysBetween = (leadingDays[1] - leadingDays[0]) / day
        const daysIndex = [0, 0, 7, 14, 28, 56].indexOf(daysBetween)

        return daysIndex === -1 ? 1 : daysIndex // if it's a weird amount, just assume daily
      },
      setBooking(data){
        this.booking.start_time = data.start_time;
        this.booking.end_time = data.end_time;
        this.booking.date = data.date;
        this.booking.recurring_id = data.recurring_id;
        this.booking.title = data.title;
        this.booking.club_id = data.club_id;

        if(data.scene_id) {
          this.booking.scene_ids = [data.scene_id];
          this.booking.field_ids = [data.field_id];
        } else {
          this.booking.scene_ids = [];
          this.booking.field_ids = [];
        }
      },
      setEventId(id){
        this.eventId = id;
      },
      getBookings(id, callback) {
        if( typeof id === 'function' && !callback ) {
          callback = id
          id = null
        }
        if(!id) {
          id = JSON.parse(auth.getProfile()).client_id
        }

        this.getBookingsSlice(id, callback)
      },
      getBookingsSlice(id, timespan, callback) {
        if( typeof id === 'function' && !callback ) {
          callback = id
          id = null
        } else if ( typeof id === 'object' && !callback ) {
          callback = timespan
          timespan = id
          id = null
        } else if ( typeof timespan === 'function' && !callback ) {
          callback = timespan
          timespan = { from: null, to: null }
        }

        if(!id) {
          id = JSON.parse(auth.getProfile()).client_id
        }

        var context = this

        requests.getBookings(this, id, timespan.from, timespan.to, function(result){
          if (result && result.data) {
            result.data.map(data => {
              data.color = context.colourMap[data.field_id % 10]
              context.recurringIds[data.id] = data.recurring_id
            })

            result.data.map(booking => {
              Object.entries(booking).map(([key, value]) => {
                if (typeof value === 'string') {
                  booking[key] = escape(value) // Escape html because the dhtmlx-scheduler allows XSS >:(
                }

                // `.text` comes in as an array of lines of strings
                if (value instanceof Array) {
                  value = value.map(val => {
                    if (typeof val === 'string') {
                      val = escape(val)
                    }
                    return val
                  })

                  if (key === 'text') {
                    booking[key] = value.join('<br/>') //Join lines together with <br/> after escaping other html
                  }
                }
              })
            })

            context.allEvents = result.data

            if(callback) {
              callback({action: 'success', events: result.data})
            }
          } else if (result && result.msg === 'No_result') {
            if (callback) {
              callback({ action: 'success', events: [] })
            }
          }

        });
      },
      doDelete(){
        var context = this;
        this.deleting = true

        requests.deleteBooking(this, this.deleteId, function(result){
          context.deleting = false
          context.showDeleteConfirm = false

          if(result.action === 'success') {
            var msg = "Successfully deleted booking.";
            if(result.data && typeof result.data === 'object' && result.data.length > 1) {
              msg = `Successfully deleted ${result.data.length} bookings.`
            };

            context.$message({
              showClose: true,
              type: 'success',
              message: msg,
            });

          } else if(result.action === 'warning') {
            var fails = val.filter(v => v.action === 'fail');

            context.$message({
              showClose: true,
              type: 'warning',
              message: `There was an issue deleting ${fails.length} booking${fails.length>1?'s':''}.\n`+ fails.map(v => v.msg).join('\n')
            });
            console.log(fails)

          } else {
            var msg = "Error deleting booking. " + (result.msg || null)
            if(result.data && typeof result.data === 'object' && result.data.length > 1) {
              msg = result.msg + '\n' + result.data.map(v => v.msg).join('\n');
            }

            context.$message({
              showClose: true,
              type: 'error',
              message: msg,
            });
            return false;
          }
          context.refreshEvents(context.fieldSelect, true);
          context.close_form()
        });

        this.deleteId = 0;
        this.deleteRecurring = false;
      },
      filterAndUpdateEvents(field_id, events) {
        var newEvents = events.filter(ev => {
          return !ev.deleted && (field_id == -1 || ev.field_id == field_id)
        })

        scheduler.clearAll();
        scheduler.parse(newEvents, 'json');
        scheduler.updateView();
      },
      formatDate(d) {
        const pad = (n) => {
          return `0${n}`.slice(-2)
        }
        d = new Date(d)
        return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`
      },
      refreshEvents(field_id, force, callback){
        var context = this;

        if (force || (new Date() - this.lastRefresh)/1000 > 45) { // It shouldn't change much in 45 seconds
          this.lastRefresh = new Date()

          const oneDay = 24*60*60*1000

          //if the scheduler hasn't loaded yet, just assume min_date is 3 days ago
          if(scheduler && scheduler.getState().mode){
            var minDate = new Date(scheduler.getState().min_date)
          } else {
            var minDate = new Date(new Date().getTime() - (3*oneDay))
          }

          var from = this.formatDate(minDate)
          var to = this.formatDate(minDate.getTime() + (30*oneDay)) //Min_time + 30 days

          this.getBookingsSlice({from, to}, function(sliceResult) {
            if(sliceResult.action === "success") {
              context.filterAndUpdateEvents(field_id, sliceResult.events)

            } else {
              context.$message({
                type: 'error',
                message: 'error getting events.'
              });
            }

            if (callback) {
              callback({slice: true})
            }

            context.getBookings(function(result) {
              if(result.action === "success") {
                context.filterAndUpdateEvents(field_id, result.events)

              } else {
                context.$message({
                  type: 'error',
                  message: 'error getting events.'
                });
              }

              if (callback) {
                callback()
              }
            })
          });

        } else {
          var newEvents = context.allEvents.filter(e =>
            e.deleted !== 1 && (field_id === -1 || e.field_id === field_id)
          )

          scheduler.clearAll();
          scheduler.parse(newEvents, 'json');
          scheduler.updateView();

          if (callback) {
            callback()
          }
        }

      },
      validateRecurringEnd(rule, value, callback) {
        // `value` is always null, because this I did it wrong and couldn't be bothered fixing it
        if(this.recurringFreq) {
          if(!this.recurringEnd) {
            callback(new Error('End date is required.'));
          }
        }
        callback();
      },
      handleFieldAddClick() {
        if (this.selObjs.length == this.booking.field_ids.length){
          this.selObjs.push(this.selObjs.length)
        }
      },
      handleFieldRemClick() {
        this.selObjs.pop()
        this.booking.field_ids.pop()
      },
      calculateRecurringStartEnd () {
        if (this.recurringIds[this.eventId]) {
          var recurringEvents = this.allEvents.filter(ev => ev.recurring_id === this.recurringIds[this.eventId])
          this.recurringStart = Math.min(...recurringEvents.map(ev => ev.start_date))
          this.recurringEnd   = Math.max(...recurringEvents.map(ev => ev.start_date))
        } else {
          this.recurringStart = this.booking.date
        }
      },
      startDelete (id) {
        this.showDeleteConfirm = true;
        this.deleteId = id;
      }
    },
    computed: {
      fieldsLabel () {
        return this.updatingBooking ? 'Field' : 'Select one (or more) fields'
      },
      recurringCount () {
        const recurringGroup = this.allEvents.filter(ev => ev.recurring_id === this.recurringIds[this.eventId]) // All in recurring group
        if (this.alsoUpdateRecurring === 1) {
          return recurringGroup.filter(booking => new Date(booking.end_time) >= new Date(`${this.booking.date} ${this.booking.end_time}`)).length
        } else if (this.alsoUpdateRecurring === 2) {
          return recurringGroup.length
        }
        return 0
      }
    },
    watch:{
      site: function(site_id){
        this.booking.scene_ids = []
        this.booking.field_ids = []
        for(var i = 0; i < this.sites.length; i++){
          if(this.sites[i].id === site_id) {
            this.fields = this.sites[i].fields;

            this.fields.map(f => f.colour = this.colourMap[f.id % 10])
            this.fields = this.fields.sort((a, b) =>
              a.field_name.localeCompare(b.field_name, 'en', { numeric: true })
            )

            if(this.fields[0] && this.fields[0].id !== -1 ) {
              this.fields.unshift({
                field_name: 'Show all',
                field_no: -1,
                id:-1,
                light_status: 0,
                site_id: this.sites[i].id,
                deleted: 0,
              });
            }

            scheduler.updateView();
          }
        }
      },
      'booking.field_ids.length': function(val) {
        this.fields.map( v => v.disabled = false )
        if(val) {
          this.fields.map( v => { if (this.booking.field_ids.indexOf(v.id) > -1 || v.field_no == -1) v.disabled = true } )
        }
      },
      'booking.field_ids': debounce(function(val) {
        this.fields.map( v => v.disabled = false )
        if(val) {
          this.fields.map( v => { if (this.booking.field_ids.indexOf(v.id) > -1 || v.field_no == -1) v.disabled = true } )
        }

        this.sceneDisabled = true;
        if(val.length){
          var context = this;

          if (!this.updatingBooking || !this.firstChange) {
            context.scenes = []
            context.booking.scene_ids = []
          } else {
            this.firstChange = false
          }

          val.map(v => {
            requests.getScenesFormatted(context, v, function(result){
              if(!result.data){
                context.$message({
                  type: 'error',
                  message: 'No scenes found'
                });
                context.booking.scene_id = '';
                return false;
              }
              context.scenes.push(...result.data);
              context.sceneDisabled = false;
              // context.booking.scene_id = result.data[0].scene_id;
            });

          })
        }
      }, 1000),
      'booking.scene_ids': function(val) {
        this.scenes.map(s => { s.disabled = false }) // Enable selection of all scenes

        val.map(v => {
          var scene = this.scenes.filter(s => s.scene_id === v)[0] // Get the scene with the selected id
          this.scenes
            .filter(s => s.field_id === scene.field_id && s.scene_id !== v)
            .map(s => { s.disabled = true }) // Get all other scenes for field and disable them
        })
      },
      fieldSelect: function(field_id) {
        this.refreshEvents(field_id);
      },
      dialogVisible: function(value) {
        var ev = scheduler.getEvent(this.eventId);
        if(!value && ev) {
          this.close_form()
        }
      },
      recurringFreq: function(val) {
        if(!val) {
          this.recurringStart = null;
          this.recurringEnd = null;
        } else {
          this.calculateRecurringStartEnd()
        }
      }
    },
    mounted: function() {
      scheduler.config.multi_day = false;
      scheduler.config.xml_date = "%Y-%m-%d %H:%i";
      scheduler.config.day_date = "%D, %d %M %y"
      scheduler.config.first_hour = 8;
      scheduler.config.last_hour = 24;
      scheduler.config.limit_time_select = true;
      scheduler.config.details_on_create = true;
      scheduler.config.details_on_dblclick = true;
      scheduler.config.drag_resize= false;
      scheduler.config.drag_move = false;
      scheduler.config.icons_select = ["icon_details", "icon_delete"];
      scheduler.locale.labels.icon_details = "Edit"

      var showModal = this.visible;
      var setBooking = this.setBooking;
      var setEventId = this.setEventId;
      var context = this;
      scheduler.showLightbox = function(id){
        var ev = scheduler.getEvent(id);

        if(ev.deleted !== undefined && ev.deleted !== 1){
          ev.update = true;
        }

        context.updatingBooking = ev.update;
        context.firstChange = ev.update;

        var s = (ev.start_date.toTimeString().split(' ')[0]).split(':')
        var start_time = s[0] + ':' + s[1];
        var e = (ev.end_date.toTimeString().split(' ')[0]).split(':')
        var end_time =  e[0] + ':' + e[1];

        var d = ev.start_date.toLocaleDateString('en-AU').split('/'); //Converts from DD/MM/YYYY to YYYY-MM-DD
        var date = d[2] + '-' + d[1] + '-' + d[0];0

        var data = {
          start_time: start_time,
          end_time: end_time,
          date: date,
          title: ev.title,
          field_id: ev.field_id,
          scene_id: ev.scene_id,
          club_id: ev.club_id || 0
        }

        setEventId(id);
        setBooking(data);

        context.calculateRecurringStartEnd()

        showModal();
      }

      scheduler.filter_day = scheduler.filter_week = scheduler.filter_month = function(id, event){
        if(event.site_id === context.site || !event.site_id || !context.site){
          return true;
        } else {
          return false;
        }
      }

      scheduler.xy.min_event_height = 21;

      scheduler.templates.event_class = function(start, end, event) {
        return "my_event show-cursor";
      };
      scheduler._click.buttons.delete = context.startDelete

      scheduler.init('scheduler', new Date(), 'week')

    },
    socket: {
      events: {
        //@params: data : {date, field_name, scene_name, start_time, end_time, site_id, field_id}
        newBooking: function(data){

          var s = new Date(data.date + ' ' + data.start_time);
          var e = new Date(data.date + ' ' + data.end_time);

          const club_name = this.clubs.find(club => club.id === data.club_id).name
          console.log(club_name)

          // console.log(data)
          var newEvent = {
            id: data.id,
            start_date: s,
            end_date: e,
            text: (data.title || data.field_name.toUpperCase() + ': ' + data.scene_name) + ` ${club_name}`,
            field_id: data.field_id,
            site_id: data.site_id,
            club_id: data.club_id,
            color: this.colourMap[data.field_id % 10],
            deleted: -1
          };
          scheduler.addEvent(newEvent);
          this.allEvents.push(newEvent);
        },
        updateBooking: function(data){
          var ev = scheduler.getEvent(data.id);
          ev.end_time = data.end_time;
          ev.end_date = new Date(data.end_date);
          ev.start_time = data.start_time;
          ev.start_date = new Date (data.start_date);
          ev.color = this.colourMap[0];
          scheduler.updateEvent(ev.id);
        },
        deleteBooking: function(id){
          // console.log('delete');
          scheduler.deleteEvent(id);
        },
        error(err) {
          console.error("Websocket error: ", err);
        }
      }
    },
    beforeMount(){

      var header = {headers: auth.getAuthHeader()};
      // var id = JSON.parse(auth.getProfile()).client_id;
      var profile = JSON.parse(auth.getProfile());
      var uri = auth.getApi();

      this.client_id = profile.client_id;
      var id = this.client_id;

      var context = this;

      if(scheduler) {
        scheduler.clearAll()
      }

/*      this.$http.get(uri + '/api/scenes/',{headers:{'x-access-token':header['headers']['x-access-token']}}).then(result=>{
        var scenes = result.body.data;
        for(var i = 0; i < scenes.length; i++){
          this.scenes.push(scenes[i]);
        }
      });
      */

      if (profile.role < 1) {
        scheduler.config.readonly = true;
      }

      if(profile.role != 3){
        requests.getSiteFields(this, id, function(result) {
          var sites = result.data;
          if(!sites){
            return false;
          }
          for(var i = 0; i < sites.length; i++){
            if(!sites[i]['fields']){
              sites[i]['fields'] = [];
            }
            context.sites.push(sites[i]);
            context.site = sites[0].id;
          }
        });

        requests.getClubs(this, function(result) {
          var clubs = result.data;
          context.clubs = context.clubs.concat(clubs);
          console.log('clubs', clubs)
        })

      } else {
        context.getAllSites();
        requests.getAllClubs(this, function(result) {
          var clubs = result.data;
          context.clubs = context.clubs.concat(clubs.slice(1)); // slice is to remove the "No Club" from the db version
        })
      }

      // this.getBookings(this, id);
      this.schedulerLoading = true
      this.refreshEvents(this.fieldSelect, true, function(result) {
        context.schedulerLoading = false
      })
    },
    beforeUpdate() {
    }
  }

</script>

<style type="text/css" media="screen">
  @import "~dhtmlx-scheduler/codebase/dhtmlxscheduler.css";

  html,
  body {
    margin: 0px;
    padding: 0px;
    height: 100%;
    display: grid;
  }

  .view-container {
    margin-bottom: 16em;
    display: block;
    height: 100%;
    background-color: #F3F3F5;
  }

  .scheduler-list {
    background-color: white;
    float: right;
  }

  .schedule .scheduler-container, .schedule .scheduler-list {
    background-color: white;
    width:100%;
    height: 800px;
  }

  .schedule .site-table {
    border: none;
    background-color: white;
  }

  .site-table .el-table::before, .el-table::after{
    background-color: unset;
  }

  .site-table tr td {
    border: none;
  }
  .site-table el-table__row {
    display: block;
    border-bottom: 1px solid #F3F3F5;
  }
  .schedule .el-table .cell {
    margin-top: 1em;
    border-bottom: 1px solid #F3F3F5
  }
  .site-table {
    text-align: left;
  }

  .site-table .site {
    color: #656565;
  }

  .schedule .site-table {
    padding-top: 15pt;
  }

  .site-select input {
    margin-top: 8pt;
    width: 100%;
  }

  .site-select .el-select{
    width: 100%;
  }

  .site-select {
    padding-top: 16pt;
    padding-bottom: 16pt;
    font-size: 1.3em;
    text-align: left;
    text-transform: uppercase;
    color:#656565;
    padding-right: 2vw;
  }

  .schedule .el-form-item__error {
    width: 100%;
    text-align: center;
  }

  .site-table .el-table__row, .show-cursor {
    cursor: pointer;
  }

  .save-btn {
    background-color: #147E9A;
    border-color: #147E9A;
  }

  .cancel-btn {
    background-color: #9B9B9B;
    border-color: #9B9B9B;
    color: white;
  }

  .cancel-btn:hover {
    background-color: #ADADAD;
    border-color: #ADADAD;
    color: white;
  }

  .time-from, .time-to {
    width: 89% !important;
  }

  .scheduler .el-form-item__label {
    text-align: left;
  }

  .scheduler .el-dialog__body {
    text-align: left;
  }

  .colourBox {
    float: left;
    width: 30px;
    height: 30px;
    margin: 5px;
    margin-top: -2px;
  }

  #scheduler .dhx_cal_select_menu .dhx_title {
    display: none;
  }

  .dhx_menu_icon.icon_details {
    background-position: -22px 0;
  }

  .my_event {
    font-family: Arial, Helvetica, sans-serif;
    padding: 2px;
  }

</style>

<style scoped>
  .el-dialog .el-date-editor {
    float: left;
  }

  .dayOptWrapper {
    margin-bottom: 30px;
  }

  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    display: none;
  }

  .el-select, .el-date-editor {
    width: 100% !important;
  }
</style>


// WEBPACK FOOTER //
// Scheduler.vue?2171132b